module.exports = __webpack_public_path__ + "img/logo@2x.83d95648.png";